<template>
    <div class="home-possible-earnings-graph">
        <div class="home-possible-earnings-graph__legend">
            <div class="home-possible-earnings-graph__legend-item _mobile-hide">
                <div class="home-possible-earnings-graph__legend-item-title" style="visibility: hidden">
                    Доходность
                </div>
                <div class="home-possible-earnings-graph__legend-item-wrap">
                    <div class="home-possible-earnings-graph__legend-item-value-name _center">
                        Среднегодовая
                    </div>
                </div>
                <div class="home-possible-earnings-graph__legend-item-wrap">
                    <div class="home-possible-earnings-graph__legend-item-value-name _center">
                        Накопленная
                    </div>
                </div>
            </div>
            <div class="home-possible-earnings-graph__legend-item"
                 v-for="(item, index) in series"
                 v-bind:key="index"
            >
                <div class="home-possible-earnings-graph__legend-item-title">
                    {{ item.name }}
                </div>
                <div class="home-possible-earnings-graph__legend-item-wrap">
                    <div class="home-possible-earnings-graph__legend-item-description" v-if="index === 0">
                        Среднегодовая доходность
                    </div>
                    <div class="home-possible-earnings-graph__legend-item-value"
                         v-bind:style="{ backgroundColor: colors[index] }"
                    >
                        {{ annualIndexes[index] }}%
                    </div>
                </div>
                <div class="home-possible-earnings-graph__legend-item-wrap">
                    <div class="home-possible-earnings-graph__legend-item-description" v-if="index === 0">
                        Накопленная доходность
                    </div>
                    <div class="home-possible-earnings-graph__legend-item-value _lite"
                         v-bind:style="{ color: colors[index] }"
                    >
                        {{ cumulativeIndexes[index] }}%
                    </div>
                </div>
            </div>
        </div>
        <div class="home-possible-earnings-graph__chart">
            <apexchart
                width="100%"
                height="100%"
                type="line"
                v-bind:options="options"
                v-bind:series="series"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'plugin-home-possible-earnings-graph',
    props: {
        annualIndexes: {
            type: Array,
            default() { return []; },
        },
        cumulativeIndexes: {
            type: Array,
            default() { return []; },
        },
        series: {
            type: Array,
            default() { return []; },
        },
        categories: {
            type: Array,
            default() { return []; },
        },
        colors: {
            type: Array,
            default() { return ['#6737AF', '#6999FF', '#FF696D', '#6CB9AD', '#EDC161']; },
        },
    },
    computed: {
        isMobile() {
            return window.innerWidth < 768;
        },
        options() {
            return {
                chart: {
                    type: 'line',
                    // height: 406,
                    toolbar: { show: false },
                    zoom: { enabled: false },
                },
                dataLabels: {
                    enabled: false,
                },
                // colors: ['#6737AF', '#6999FF', '#FF696D', '#6CB9AD', '#EDC161'],
                colors: this.colors,
                stroke: {
                    width: 2,
                    curve: 'straight', // default, straight, smooth
                },
                markers: {
                    size: 3,
                    strokeWidth: 0,
                    hover: {
                        size: 9,
                    },
                },
                legend: {
                    show: false,
                    position: 'top',
                    horizontalAlign: 'center',
                    markers: { width: 12, height: 12, radius: 12 },
                },
                grid: {
                    show: false,
                },
                tooltip: {
                    custom: ({ series, dataPointIndex, w }) => {
                        const seriesHtml = series.map((serie, i) => {
                            const value = serie[dataPointIndex];

                            if (value === undefined || value === null) return '';

                            const name = w.globals.seriesNames[i];
                            const color = w.globals.colors[i];

                            const calcValue = value - 100;
                            const formattedValue = `${calcValue > 0 ? '+' : ''}${calcValue}%`;

                            return `
                                <div style="display: grid; grid-template-columns: 20px 1fr 40px; gap: 8px; padding-bottom: 6px;">
                                    <div style="display: flex; align-items: center; justify-content: center; padding-bottom: 2px;">
                                        <span style="display: inline-block; width: 20px; height: 2px; background-color: ${color};"></span>
                                    </div>
                                    <span>${name}</span>
                                    <span><strong>${formattedValue}</strong></span>
                                </div>
                            `;
                        }).join('');

                        return `
                          <div style="padding: 12px; background: #27242D; color: white; font-size: 12px; border-radius: 8px;">
                            <div style="font-weight: bold;">
                              ${this.formatDateToQuarter(this.categories[dataPointIndex])}
                            </div>
                            <div style="margin-top: 6px;">
                              ${seriesHtml}
                            </div>
                          </div>
                        `;
                    },
                },
                yaxis: {
                    title: {
                        text: 'Индекс, %',
                        style: {
                            fontSize: this.isMobile ? '14px' : '18px',
                            fontFamily: 'Noah, Arial, sans-serif',
                        },
                    },
                    min: 50,
                    max: 300,
                    tickAmount: 5,
                    axisBorder: {
                        show: true,
                        color: '#d1d5db',
                        width: 1,
                    },
                },
                xaxis: {
                    // title: { text: 'Год' },
                    categories: this.categories || [],
                    labels: {
                        formatter(value) {
                            const date = new Date(value);
                            if (date?.getMonth() === 11) {
                                // return "'" + String(date.getFullYear()).slice(-2);
                                return date.getFullYear();
                            }
                            return '';
                        },
                        rotate: 0,
                        rotateAlways: false,
                        offsetX: 0,
                        offsetY: 0,
                        style: {
                            fontSize: this.isMobile ? '14px' : '16px',
                            fontWeight: 600,
                        },
                    },
                    axisBorder: {
                        show: true,
                        color: '#EFEDF1',
                        height: 1,
                    },
                },
            };
        },
    },
    methods: {
        formatDateToQuarter(dateString) {
            const [yearFull, monthStr] = dateString.split('-');
            const month = parseInt(monthStr, 10);
            const quarter = Math.ceil(month / 3);
            const shortYear = yearFull.slice(-2);
            return `${quarter} квартал ‘${shortYear}`;
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.home-possible-earnings-graph {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 530px;

    &__legend {
        flex-shrink: 0;
        display: flex;
        justify-content: space-evenly;
        gap: 12px;

        padding-left: 64px;

        &-item {
            .typography-heading();

            display: flex;
            align-items: flex-start;
            flex-direction: column;
            gap: 2px;
            &-title {
                text-transform: uppercase;
            }
            &-wrap {
                display: flex;
                align-items: center;
                gap: 4px;
            }
            &-description {
                display: none;
            }
            &-value {
                padding: 2px 8px;
                color: white;
                border-radius: @border-radius-md;
                &._lite {
                    padding: 2px 2px;
                }
                &-name {
                    .typography-caption();
                    font-weight: normal;
                    &._center {
                        height: 28px;
                        display: flex;
                        align-items: center;
                    }
                }
            }
        }
    }
    &__chart {
        flex: 1;
    }
    @media (max-width: 1400px) {
        &__legend {
            padding-left: 0;
        }
    }

    @media @media-md-down {
        height: 352px;

        &__legend {
            flex-wrap: wrap;
            gap: 4px;
            padding-left: 0;

            &-item {
                .typography-caption();

                gap: 0;
                font-weight: bold;
                &-wrap {
                    position: relative;
                    padding-top: 26px;
                }
                &-description {
                    .typography-caption();

                    position: absolute;
                    display: block;
                    left: 0;
                    top: 6px;
                    width: 300px;

                    font-weight: normal;
                }
                &-value {
                    padding: 2px 4px 0 4px;
                    border-radius: @border-radius-sm;

                    &-name {
                        display: none;
                    }
                }
                &._mobile-hide {
                    display: none;
                }
            }
        }
        &__chart {
            height: 234px;
        }
    }
}
</style>
